import { UniversityStudyRoomTemplate } from "@/components/UniversityStudyRoomTemplate";

const UniversityOfTexasAustin = () => {
  return (
    <UniversityStudyRoomTemplate
      universityName="University of Texas at Austin"
      universityShortName="UT Austin"
      slug="university-of-texas-austin"
      seoTitle="UT Austin Study Rooms | PCL Library Study Spaces"
      seoDescription="Find study rooms at UT Austin including Perry-Castañeda Library. Learn booking policies, quiet floors, and discover CSW as an online alternative."
      seoKeywords="UT Austin study rooms, PCL study rooms, University of Texas library, Austin study spaces, Longhorn study rooms"
      canonicalUrl="/study-room/university-of-texas-austin/"
      heroDescription="Discover UT Austin's iconic PCL and inspiring study spaces across campus."
      libraryWebsiteUrl="https://lib.utexas.edu"
      libraryWebsiteName="UT Libraries"
      studySpaces={[
        {
          name: "Perry-Castañeda Library (PCL) - Group Rooms",
          features: "UT students only, 1-hour blocks up to 4 hours/week. Min 2 people, 15-min check-in.",
          feedback: "Quiet floors praised for intense focus. Some noise spillover from group floors."
        },
        {
          name: "PCL - Quiet Floors",
          features: "Designated silent study areas on upper floors.",
          feedback: "Best late at night when the library empties. Near-silence after midnight."
        },
        {
          name: "Scholars Lounge",
          features: "Vibrant colors, intuitive seating, collaborative environment.",
          feedback: "Newly opened, inspiring atmosphere for group work."
        },
        {
          name: "Life Sciences Library",
          features: "Airy environment, natural lighting, individual study spaces.",
          feedback: "Great for science students seeking a change of scenery."
        }
      ]}
      guideContent={
        <>
          <p>
            UT Austin's Perry-Castañeda Library (PCL) has group study rooms for UT students only. Rooms can be reserved 
            in one-hour blocks for up to four hours per week; groups must have at least two people and check in within 15 minutes.
          </p>
          <p className="mt-4">
            Students praise the quiet floors of PCL for intense focus, especially late at night when the library empties. 
            The newly opened Scholars Lounge features vibrant colors and intuitive seating for collaboration.
          </p>
          <p className="mt-4">
            Book a PCL group room for structured group work; if you need an inspiring environment, try the Scholars Lounge 
            or the airy Life Sciences Library. Night owls should visit the quiet floors after midnight for near-silence.
          </p>
        </>
      }
      summaryTips={[
        "Group rooms limited to 4 hours per week",
        "Check in within 15 minutes or lose reservation",
        "Quiet floors are best after midnight",
        "Scholars Lounge is great for collaborative work",
        "UT students only for PCL group rooms"
      ]}
    />
  );
};

export default UniversityOfTexasAustin;
